/* Swiss Notes — normal cards stay on 100ML; bundle catalogue remains size-aware. */
(() => {
  'use strict';
  const isBundleCatalogue = () => /^\/collections\/all\/?$/.test(window.location.pathname);
  if (isBundleCatalogue()) return;

  const lockNormalCards = (root = document) => {
    root.querySelectorAll('product-card.product-card').forEach((card) => {
      card.querySelectorAll('input[data-variant-media], input[data-variant-secondary-media]').forEach((input) => {
        input.removeAttribute('data-variant-media');
        input.removeAttribute('data-variant-secondary-media');
      });

      const img = card.querySelector('.product-card__image--primary');
      const actions = card.querySelector('.product-card__actions[data-sn-variants]');
      if (!img || !actions) return;

      let variants;
      try { variants = JSON.parse(actions.dataset.snVariants || '[]'); } catch (e) { return; }
      const v100 = variants.find((v) => /(^|\b)100\s*ML(\b|$)/i.test(String(v.size || '')) && v.image);
      if (!v100) return;

      if (img.getAttribute('src') !== v100.image) img.setAttribute('src', v100.image);
      img.removeAttribute('srcset');

      /* The set builder uses this payload to repaint cards to the last selected bundle size.
         Normal cards do not participate in that flow, so detach only this runtime hook after
         resolving the 100ML image. The bundle catalogue route above is left completely untouched. */
      actions.removeAttribute('data-sn-variants');
    });
  };

  const start = () => {
    lockNormalCards();
    let queued = false;
    new MutationObserver((mutations) => {
      if (!mutations.some((m) => m.addedNodes && m.addedNodes.length)) return;
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        lockNormalCards();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
